import { Component } from '@angular/core';

@Component({
    selector: 'painel',
    templateUrl: 'painel.html'
})
export class PainelPage {
    constructor() { }
}


// WEBPACK FOOTER //
// ./src/pages/painel/painel.ts